import React from "react"
import utilStyles from "../../asset/styles/util/util.module.scss"
import Grid from "@mui/material/Grid"
import InputText from "component/inputText/inputText"
import Select from "component/select/select"
import Toggle from "component/toggle/Toggle"
import styles from "../../asset/styles/excursionDetail/excursionDetail.module.scss"
import { ExcursionDetailModel } from "../../models"
import Checkbox from "component/checkbox/checkbox"
import { toTitleCase } from "util/textcase"

export interface SelectOption {
    label: string
    value: string
}

interface ExcursionBasicDetailProps {
    excursion: ExcursionDetailModel
    cityOptions: SelectOption[]
    // typeOptions: SelectOption[]
    onChange: (updates: Partial<ExcursionDetailModel>) => void
    readOnly?: boolean
    errors?: { excursion_name?: string; city?: string }
}

const ExcursionBasicDetail: React.FC<ExcursionBasicDetailProps> = ({
    excursion,
    cityOptions,
    // typeOptions,
    onChange,
    readOnly = false,
    errors = {},
}) => {
    const handleCityChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value
        const option = cityOptions.find((o) => o.value === value)
        onChange({
            city_id: value ? Number(value) : 0,
            city_name: option?.label ?? "",
        })
    }

    // const handleTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    //     const value = e.target.value
    //     const option = typeOptions.find((o) => o.value === value)
    //     onChange({
    //         excursion_type_id: value ? Number(value) : 0,
    //         excursion_type_name: option?.label ?? "",
    //     })
    // }

    return (
        <div className={utilStyles.pageContainerContent}>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 6 }}>
                    <InputText
                        label="Excursion Name"
                        value={toTitleCase(excursion.excursion_name)}
                        onChange={(e) => onChange({ excursion_name: e.target.value })}
                        placeholder="Enter excursion name"
                        disabled={readOnly}
                        error={errors.excursion_name}
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 3 }}>
                    <Select
                        label="City"
                        value={toTitleCase(String(excursion.city_id))}
                        onChange={handleCityChange}
                        placeholder="Select city"
                        options={cityOptions}
                        error={errors.city}
                    />
                </Grid>
                {/* <Grid size={{ xs: 12, md: 3 }}>
                    <Select
                        label="Type"
                        value={String(excursion.excursion_type_id)}
                        onChange={handleTypeChange}
                        placeholder="Select type"
                        options={typeOptions}
                    />
                </Grid> */}
                <Grid size={{ xs: 12, md: 3 }}>
                    <div className={styles.statusField}>
                        <label className={styles.fieldLabel}>Status</label>
                    </div>
                    <div className={styles.statusToggle}>
                        <Toggle
                            leftLabel="Inactive"
                            rightLabel="Active"
                            checked={excursion.flag_active}
                            onChange={(checked) => onChange({ flag_active: checked })}
                        />
                    </div>
                </Grid>
                <Grid size={{ xs: 12, md: 12 }}>
                    <Checkbox
                        label="Set As Default Excursion For This City"
                        checked={excursion.flag_default ?? false}
                        onChange={(checked) => onChange({ flag_default: checked })}
                        disabled={readOnly}
                    />
                </Grid>
            </Grid>
        </div>
    )
}

export default ExcursionBasicDetail
